import { jsxs as O, Fragment as P, jsx as R } from "react/jsx-runtime";
import { BadRequest as j } from "@systemeio/util";
import { useStore as Y, useOfferStore as $, useXenditStore as J } from "../../store/index.mjs";
import z from "../../ui-kit/theme-button.mjs";
import { getCardHolderFirstLastName as G } from "../payment-inputs/get-card-holder-first-last-name.mjs";
import { useXenditBuyOffer as K } from "./api/index.mjs";
import { useLoadXenditScript as Q } from "./hooks/use-load-xendit-script.mjs";
import { useXenditThreeDs as U } from "./hooks/use-xendit-three-ds.mjs";
import { XenditCreditCardStatusEnum as n } from "./types/index.mjs";
import { useTranslation as V, ContactSlugEnum as p, toast as a } from "@systemeio/ui";
import { twJoin as W } from "tailwind-merge";
function se({
  isFetching: _,
  buttonTitle: h,
  buttonDisabled: y,
  setIsFetching: r,
  preSubmit: c,
  handleBadRequest: w,
  hasErrors: b
}) {
  const { t: u } = V(), { locale: x } = Y(), { xenditBuyOffer: X } = K(), { currency: l, finalAmount: i } = $(), { cardNumber: N, cardHolderName: v, cvc: S, expiryMonth: D, expiryYear: B, formInvalid: m } = J(), { isScriptLoading: k } = Q(), { openLinkInIframe: f, threeDsModal: E, closeThreeDsModal: H } = U(
    () => r(!1)
  ), L = async (o, e) => {
    if (o) {
      a.error(o.message), r(!1);
      return;
    } else if (e.status === n.in_review)
      f(e.payer_authentication_url);
    else if (e.status === n.verified) {
      setTimeout(() => {
        H();
      }, 1e3);
      try {
        const t = c();
        if (!t) return;
        const { redirect: s } = await X(
          {
            ...t,
            options: { token: e.credit_card_token_id }
          },
          x
        );
        if (s) {
          window.location.assign(s);
          return;
        } else
          a.error(u("public_pages_purchase.error"));
      } catch (t) {
        if (t instanceof j)
          w(t);
        else
          throw t;
      } finally {
        r(!1);
      }
    }
  }, T = async (o, e) => {
    if (o) {
      a.error(o.message), r(!1);
      return;
    }
    if (!window.Xendit || !i) {
      a.error(u("public_pages_purchase.error")), r(!1);
      return;
    }
    e.status === n.verified ? window.Xendit.card.createAuthentication(
      {
        amount: i,
        token_id: e.id
      },
      L
    ) : e.status === n.in_review ? f(e.payer_authentication_url) : e.status === n.failed && (a.error(u("public_pages_purchase.error")), r(!1));
  }, g = async (o) => {
    o.preventDefault(), r(!0);
    try {
      const e = c();
      if (!e || !i || !l) return;
      if (window.Xendit) {
        const t = `20${B}`, { firstName: s = "", lastName: q = "" } = G(v), A = e.customer.fields[p.Email] ?? "", d = e.customer.fields[p.PhoneNumber] ?? "", M = d ? `+${d}` : "";
        window.Xendit.card.createToken(
          {
            amount: i,
            card_number: N,
            card_exp_month: D,
            card_exp_year: t,
            card_cvn: S,
            card_holder_first_name: s,
            card_holder_last_name: q,
            card_holder_email: A,
            card_holder_phone_number: M,
            is_multiple_use: !0,
            should_authenticate: !0,
            currency: l
          },
          T
        );
      }
    } catch (e) {
      throw e;
    } finally {
      r(!1);
    }
  };
  return /* @__PURE__ */ O(P, { children: [
    E,
    /* @__PURE__ */ R(
      z,
      {
        className: W(
          "main-transition-colors",
          (b || m) && "bg-danger focus:bg-danger"
        ),
        onClick: g,
        isFetching: _,
        disabled: k || m || y,
        type: "submit",
        children: h
      }
    )
  ] });
}
export {
  se as XenditPaymentButton
};
